var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClusterNor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cluster_nor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nav",
    transform: "translate(-812.000000, -200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-17",
    transform: "translate(812.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u8499\\u7248"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.59254077,0.574551918 C5.68799431,-0.148957905 7.08247589,-0.189152895 8.21115477,0.453966947 L8.40745923,0.574551918 L12.0899767,3.00672952 C12.6102635,3.35036127 12.9413635,3.9177542 12.9929338,4.53975409 L13,4.71061722 L13,9.55065308 C13,10.2191247 12.6768394,10.840974 12.1423829,11.2187424 L12.0044315,11.3079852 L8.25775513,13.5189757 C7.23484833,14.122614 5.98606376,14.1581222 4.9365831,13.6255001 L4.74224487,13.5189757 L0.995568497,11.3079852 C0.426672869,10.9722682 0.059751042,10.3760154 0.00666777647,9.71668542 L0,9.55065308 L0,4.71061722 C0,4.08008677 0.287742776,3.48878561 0.772885353,3.10586798 L0.910023299,3.00672952 L4.59254077,0.574551918 Z M7.86247088,1.42649577 C7.08920955,0.915782955 6.1073529,0.881735434 5.30627886,1.32435321 L5.13752912,1.42649577 L1.45501165,3.85867337 C1.20669294,4.02267943 1.04456368,4.28862628 1.00791134,4.58295375 L1,4.71061722 L1,9.55065308 C1,9.87250979 1.14983305,10.1727501 1.39955414,10.3632134 L1.49778425,10.4293191 L5.24446062,12.6403097 C5.96532288,13.0657053 6.8432337,13.0960907 7.58653146,12.7314659 L7.75553938,12.6403097 L11.5022158,10.4293191 C11.7761285,10.2676776 11.9563963,9.98523899 11.9930741,9.67016389 L12,9.55065308 L12,4.71061722 C12,4.40968223 11.8689106,4.12661927 11.6460192,3.93498849 L11.5449884,3.85867337 L7.86247088,1.42649577 Z",
    id: "\\u8DEF\\u5F84-6",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6.79317713e-15,
    y1: 2.30769231,
    x2: 2.8125,
    y2: 2.30769231,
    id: "\\u8DEF\\u5F84-2",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.3125,
    y1: 2.30769231,
    x2: 9,
    y2: 2.30769231,
    id: "\\u8DEF\\u5F84-2\\u5907\\u4EFD",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10542736e-15,6 L1.4141745,6 C1.96349808,6 2.50493441,5.86926441 2.99373213,5.61859891 L5.12917858,4.52349816 C5.45504373,4.35638783 5.81600128,4.26923077 6.182217,4.26923077 L9,4.26923077 L9,4.26923077",
    id: "\\u8DEF\\u5F84-3",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,4.26923077 L0.818701172,4.26923077 C1.52958091,4.2682631 2.16757883,3.83271471 2.42703886,3.17087517 C3.25837819,1.05695839 4.06186523,0 4.8375,0 C6.1875,0 7.3125,2.30769231 7.875,4.03846154",
    id: "\\u8DEF\\u5F84-4",
    stroke: "currentColor"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClusterNor);
export default __webpack_public_path__ + "static/media/cluster_nor.9c3a9d4565bdbaf9b584c481aa19f5f2.svg";
export { ForwardRef as ReactComponent };